<template>
  <el-main class="form_main">
    <div class="tab_title" v-if="$route.path == '/supplier/add'">基本信息</div>
    <div style="height: 16px;" v-if="$route.path == '/supplier/add'"></div>
    <div class="tab_content">
      <div class="center" style="flex-direction: column;">
        <SupplierNetworkForm :supplier_info="supplier_info" :is_edit="is_edit" ref="supplierNetworkForm"></SupplierNetworkForm>
        <div style="width: 100%; height: 70px"></div>
      </div>
    </div>

    <div class="preservationBox center">
      <el-button @click="clickBack">返回</el-button>
      <el-button type="primary" @click="saveForm" v-if="is_edit">提交</el-button>
      <el-button type="primary" @click="enterWebControl" v-if="supplier_info.applicationStatus == 'COMPLETED'">进入后台</el-button>
    </div>
  </el-main>
</template>

<script>
import SupplierNetworkForm from '@/views/supplierForm/supplier_network_form.vue';
import { setAddRouter } from '@/router/index.js'

export default {
  components: {
    SupplierNetworkForm,
  },
  data() {
    return {
      supplier_id: null,
      supplier_info: {},
    };
  },
  computed: {
    is_edit() {
      let flag = false;
      if (this.$route.path == '/supplier/edit' && (this.supplier_info.applicationStatus == 'REVIEW_BACK' || this.supplier_info.applicationStatus == '')) {
        flag = true;
      }
      if(this.$route.path == '/supplier/add'){
        flag = true;
      }
      return flag;
    },
  },
  methods: {
    enterWebControl(){
      // setAddRouter()
      this.$router.push('/index')
    },
    clickBack(){
      if(this.supplier_info.applicationStatus == 'COMPLETED'){
        this.$router.push('/index')
      }else{
        this.$router.back(-1);
      }
    },
    saveForm() {
      let that = this;
      this.$refs.supplierNetworkForm.submitNetworkInfo(() => {
        if (this.supplier_info.store_net_info.id) {
          that.getSupplierInfo();
        } else {
          that.$router.back(-1);
        }
      });
    },
    getSupplierInfo() {
      this.$axios.post(this.$api.supplier.info)
        .then((res) => {
          if (res.code == 0) {
            if (!res.result.pid) res.result.pid = '';
            if (!res.result.store_net_info)
              res.result.store_net_info = {
                licenceNo: '',
                new_openAccountLicenceUrl: '',
                new_licenceUrl: '',
                contactName: '',
                signName: '',
              };
            if (res.result.pid) {
              res.result.store_net_info.new_store_type = 3; 
            }
            this.supplier_info = res.result;
            if(this.supplier_info.applicationStatus == 'COMPLETED'){
              this.$store.commit('user/setSkipType', 3);
            }
            this.$nextTick(() => {
              this.$refs.supplierNetworkForm.setFormData();
            });
          }
        });
    },
  },
  created() {
    if(this.$route.path == '/supplier/edit'){
      this.getSupplierInfo();
    }
  },
};
</script>

<style lang="less" scoped>
.el-main {
  height: 100%;
  background-color: #fff;
}
.tab_title {
  line-height: 40px;
  border-bottom: 1px solid #e4e7ed;
}
.form_main {
  width: 100%;
  display: flex;
  flex-direction: column;

  .el-tabs {
    width: 100%;
  }
  .tab_content {
    width: 100%;
    flex: 1;
    overflow-y: auto;
  }
}
.preservationBox{
  width: 100%;
  height: 70px;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 1;
  background-color: #fff;
  box-shadow: 0 0 8px 2px rgba(64, 158, 255, 0.2);
}
</style>
